var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('collapse-default'),_c('accordion-default'),_c('collapse-types'),_c('collapse-hover'),_c('collapse-boostrap-vue')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }